<!--
 * @Author: your name
 * @Date: 2022-02-23 10:26:16
 * @LastEditTime: 2022-09-20 17:43:54
 * @Description: 三方下单
 * @FilePath: \jmssa-vip-customers-front\src\views\place-order\external-order\ExternalOrdersNo.vue
-->
<template>
  <div class="main-wrap externalOrder">
    <div class="externalOrder-top">
      <div class="search-btns">
        <el-form :inline="true">
          <el-form-item v-if="exportStatus === 100">
            <el-button type="primary" @click="setOrder" :loading="keyBtn" :disabled="multipleSelection.length > 0 ? false : true" class="h40">{{
              keyBtn ? $lang('下单中...') : $lang('立即下单')
            }}</el-button>
          </el-form-item>
          <el-form-item v-if="exportStatus === 100">
            <el-button
              type="primary"
              class="h40"
              @click="batchCancelOrder"
              :disabled="multipleSelection.length > 0 ? false : true"
              icon="iconfont iconshanchu"
              :loading="cancelLoading"
              >{{ $lang('批量取消') }}</el-button
            >
          </el-form-item>
          <el-form-item v-if="exportStatus === 100">
            <el-button type="primary" class="h40" @click="shopifyAddrDialog = true" :disabled="multipleSelection.length > 0 ? false : true" icon="iconfont iconbianji">{{
              $lang('修改发货仓库')
            }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button icon="iconfont iconxiazai" type="primary" size="small" :loading="shopifyLoading" @click="shopifyGet" class="h40" plain>{{
              $lang('同步shopify订单')
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="search-condition" id="jmsSearch">
        <el-form :model="searchParam" ref="seach" :inline="true">
          <el-form-item prop="date">
            <el-date-picker
              :clearable="false"
              v-model="searchParam.date"
              type="daterange"
              :range-separator="$lang('至')"
              :start-placeholder="$lang('开始时间')"
              :end-placeholder="$lang('结束时间')"
              class="commonSize"
              @change="selectDate"
              :default-time="['00:00:00', '23:59:59']"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item prop="customerOrderId">
            <el-input v-model="searchParam.customerOrderId" :placeholder="$lang('客户订单号')"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchChange" icon="iconfont iconchaxun" class="h32">{{ $lang('查询') }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" plain @click="resetSearch" icon="iconfont iconshanchu" class="h32">{{ $lang('清空') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="externalOrder-bottom">
      <div class="tabs-nav">
        <div class="tabs-nav-item" v-for="(item, index) in menuItems" :key="index" @click="changeTab(index)" :class="{ active: tabActive === index }">
          {{ $lang(item.orderStatusName) }}<span class="tabs-nav-item-count">{{ item.total }}</span>
        </div>
      </div>

      <JmsTableScroll
        ref="table"
        :option="listOpt"
        :data="tableList"
        :page="page"
        :table-loading="loading"
        @size-change="sizeChange"
        :isCheckedAll="isCheckedAll"
        @select-all="handleSelectAll1"
        @select="handleSelectionChange"
        @current-change="currentChange"
      >
        <template slot="orderStatusName" slot-scope="data">
          <!-- <span class="dot" :class="data.row.orderStatusName=='待打印'?'oragin':''" v-show="data.row.orderStatusName=='待打印'">{{data.row.orderStatusName}}</span> -->
          <span class="dot" :class="data.row.orderStatusName == '已打印' ? 'oragin' : ''" v-show="data.row.orderStatusName == '已打印'">{{ $lang('未取件') }}</span>
          <span class="dot" :class="data.row.orderStatusName == '已取件' ? 'green' : ''" v-show="data.row.orderStatusName == '已取件'">{{ data.row.orderStatusName }}</span>
          <span class="dot" v-show="data.row.orderStatusName == '已取消'">{{ data.row.orderStatusName }}</span>
        </template>
        <template slot="menu" slot-scope="data">
          <div>
            <!-- 查看按钮 -->
            <el-button @click="rowView(data.row)" type="text">{{ $lang('查看') }}</el-button>
          </div>
        </template>
      </JmsTableScroll>
    </div>

    <!-- 订单详情弹框组件 -->
    <bullet ref="bullet" :orderType="orderType" :viewDialogVisible="viewDialogVisible" @closeDetails="closeDetails" :bulletTitle="1" :rowData="rowData"></bullet>

    <!-- 订单下单失败弹框组件 -->
    <fail-order ref="failOrder" :failList="failData"></fail-order>
    <!-- 仓库地址弹窗 -->
    <el-dialog :title="$lang('选择发货仓库')" :visible.sync="shopifyAddrDialog" :close-on-click-modal="false" :modal-append-to-body="true" width="600px">
      <div class="dialog-center">
        <div style="margin-bottom:15px">
          <el-button @click="shopifyAddressListGet" type="text">{{ $lang('获取最新仓库信息') }}</el-button>
        </div>
        <el-radio-group v-model="inventoryAddressId">
          <el-radio :label="item.inventoryId" v-for="item in shopifyAddrList" :key="item.id">{{ item.inventoryName }}</el-radio>
        </el-radio-group>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" class="h40" @click="batchAddrUpdate" :loading="shopifyLoading">{{ $lang('确认') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import JmsTableScroll from '@/components/jms-widget/jms-table-scroll'
import mixin from '@/mixins/mixin.js'
import {
  orderListThridNo,
  orderTotalGroupThridNo,
  detailOrder,
  batchSave,
  cancelById,
  shopifyOrderSync,
  shopifyAddressList,
  shopifyOrderAddrUpdate,
  shopifyMyStore
} from '@/api/module/customer'
import bullet from '@components/base/BaseBulletThird.vue'
import failOrder from './components/FailOrder.vue'
import { commonFun, taday } from '@utils/common'
import { RESPONSE_SUCCESS } from '@constants'
import { mapActions } from 'vuex'
export default {
  name: 'ExternalOrdersNo',
  mixins: [mixin],
  components: {
    JmsTableScroll,
    bullet,
    failOrder
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          const space = 90 * 24 * 3600 * 1000
          const minTime = new Date().getTime() - space
          const maxTime = new Date(taday.end).getTime()
          return time.getTime() < minTime || time.getTime() > maxTime
        }
      },
      COM_HTTP: {
        reqList: orderListThridNo,
        reqDetail: detailOrder
      },
      isShowFirst: false,
      searchParam: {
        date: commonFun.GetTodayDate(),
        startTime: commonFun.GetTodayDate()[0], // 开始时间，格式：yyyy-MM-dd HH:mm:ss
        endTime: commonFun.GetTodayDate()[1], // 结束时间，格式：yyyy-MM-dd HH:mm:ss
        orderStatusCode: 100, // 页签（all，already_print，already_pick，already_cancle）
        customerOrderId: ''
      },
      orderSourceCodeList: [], // 下单渠道
      menuItems: [], // tab菜单
      multipleSelection: [], // 多选或全选数据
      disabled: true, // 禁止点击状态
      exportStatus: 100, // 未下单的code， 100-未下单，101-商户取消，102-平台取消
      selectId: '', // 当前选中的id
      isCheckedAll: false,
      isKeyUp: false,
      page: {
        // 分页配置
        current: 1,
        size: 100,
        total: 0,
        sizes: [50, 100, 200, 500, 1000]
      },
      tabActive: 0, // tab 选中
      // 21117,多国合一，根据用户的国家code，行政区域的label有变化，下面是沙特(原来)的行政区划
      senderProvinceName: this.$lang('寄件省份'),
      senderCityName: this.$lang('寄件城市'),
      receiverProvinceName: this.$lang('收件省份'),
      receiverCityName: this.$lang('收件城市'),
      orderType: 'thridNo',
      keyBtn: false,
      cancelLoading: false,
      failData: [],
      shopifyLoading: false, // 同步shopify订单
      inventoryAddressId: '', // 仓库地址选中
      shopifyAddrDialog: false, // 仓库地址弹窗
      shopifyAddrList: [], // 仓库信息
      shopifyDomain: ''
    }
  },
  async created() {
    this.isSinleSelection = []
    // 获取订单来源数据
    const key = this.$route.params.typeNum
    // this.getOrderOrigin(key)
    await this.getShopifyStore()
    this.shopifyAddressListGet()
    await this.orderTotalGroupThridNo(this.searchParam)
    if (key) {
      this.handleSelect(key)
    } else {
      this.searchFun()
    }
  },
  computed: {
    listOpt() {
      const that = this
      return {
        border: true,
        selection: true,
        menu: true,
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        rowKey: '$index',
        fixHeight: 90,
        //  搜索框和表格列及其字段
        column: [
          {
            label: '客户订单号',
            prop: 'customerOrderId',
            width: 150
          },
          {
            label: '寄件人姓名',
            prop: 'senderName'
          },
          {
            label: '寄件人手机号',
            prop: 'senderMobilePhone'
          },
          {
            label: that.senderProvinceName,
            prop: 'senderProvinceName'
          },
          {
            label: that.senderCityName,
            prop: 'senderCityName'
          },
          {
            label: '寄件街道',
            prop: 'senderStreet'
          },
          {
            label: '寄件详细地址',
            prop: 'senderDetailedAddress'
          },
          {
            label: '收件人姓名',
            prop: 'receiverName'
          },
          {
            label: '收件人手机号',
            prop: 'receiverMobilePhone'
          },
          {
            label: that.receiverProvinceName,
            prop: 'receiverProvinceName'
          },
          {
            label: that.receiverCityName,
            prop: 'receiverCityName'
          },
          {
            label: '收件街道',
            prop: 'receiverStreet'
          },
          {
            label: '收件详细地址',
            prop: 'receiverDetailedAddress'
          },
          {
            label: '物品类型',
            prop: 'goodsTypeName'
          },
          {
            label: '物品名称',
            prop: 'goodsName'
          },
          {
            label: '物品重量',
            prop: 'packageTotalWeight'
          },
          {
            label: '产品类型',
            prop: 'expressTypeName'
          },
          {
            label: '结算方式',
            prop: 'paymentModeName'
          },
          {
            label: '代收货款金额',
            prop: 'codMoney'
          },
          {
            label: '代收货款币别名称',
            prop: 'codCurrencyTypeName'
          }
        ]
      }
    },
    // 用户信息
    userInfo() {
      return this.$store.state.base.user || {}
    },
    countryCode() {
      return this.$store.state.base.user.countryCode || ''
    }
  },
  watch: {
    tableList: {
      handler(oldVal, newVal) {
        if (this.isKeyUp && this.exportStatus === 'already_print' && this.tableList.length === 1 && this.autoPrint) {
          this.autoPrint = false
          this.multipleSelection = this.tableList
          this.$nextTick(() => {
            this.$refs.table.$refs.table.toggleRowSelection(this.tableList[0], true)
            this.$refs.printOrder && this.$refs.printOrder.$refs.btnPrint.$el.click()
          })
        }
      },
      deep: true
    },
    countryCode: {
      handler(val) {
        const that = this
        if (val === 'UAE') {
          // 阿联酋的用户行政区域要变
          that.senderProvinceName = that.$lang('寄件酋长国')
          that.senderCityName = that.$lang('寄件区域')
          that.receiverProvinceName = that.$lang('收件酋长国')
          that.receiverCityName = that.$lang('收件区域')
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions(['LOGIN_OUT', 'SET_USER', 'UPDATE_PRINT_STOCK']),

    /**
     * @description: 獲取shopify 店铺列表
     * @param {*}
     * @return {*}
     */
    async getShopifyStore() {
      const res = await shopifyMyStore()
      try {
        if (res.code === RESPONSE_SUCCESS && res.data) {
          this.shopifyDomain = res.data.storeDomain
        }
      } catch (error) {
        this.shopifyDomain = ''
      }
    },
    // 选择分页条数
    sizeChange(val, list) {
      this.page.current = 1
      this.page.size = val
      this.searchFun()
      this.multipleSelection = []
      this.isCheckedAll = false
    },
    // 跳转页码
    currentChange(val) {
      this.page.current = val
      this.searchFun()
      this.multipleSelection = []
      this.isCheckedAll = false
    },
    handleCompositionEnd(e) {
      // 中文输入法回车事件
      const { data } = e || {}
      if (data.length > 11) {
        this.searchParam.startTime = commonFun.getBeforeDate(30) + ' 00:00:00'
        this.searchParam.endTime = commonFun.GetTodayDate()[1] // 开始时间，格式：yyyy-MM-dd HH:mm:ss
        this.searchParam.date = [this.searchParam.startTime, this.searchParam.endTime]
        this.searchChange()
      }
    },
    toKeyUp(e) {
      if (this.isKeyUp) {
        // 回车搜索后首次输入清空输入框
        this.isKeyUp = false
      }
      return true
    },
    async payCode(e) {
      // const code = e.keyCode || e.which
      // if (code === 13) {
      this.isKeyUp = true
      this.autoPrint = true
      const nos = this.searchParam.customerWaybillNos
      if (nos.length === 0 || (nos.length > 0 && nos[0] === '')) {
        this.searchParam.customerWaybillNos = []
      } else {
        this.searchParam.startTime = commonFun.getBeforeDate(30) + ' 00:00:00'
        this.searchParam.endTime = commonFun.GetTodayDate()[1] // 开始时间，格式：yyyy-MM-dd HH:mm:ss
        this.searchParam.date = [this.searchParam.startTime, this.searchParam.endTime]
        this.searchFun(1)
        // await this.searchChange()
      }
      // }
    },

    /**
     * @description: 获取shopify 仓库信息
     * @param {*}
     * @return {*}
     */
    async shopifyAddressListGet() {
      this.shopifyLoading = true
      const { code, data } = await shopifyAddressList({ domain: this.shopifyDomain || '' })
      if (code === RESPONSE_SUCCESS && data) {
        this.shopifyAddrList = data
      } else {
        this.shopifyAddrList = []
      }
      this.$nextTick(() => {
        this.shopifyLoading = false
        this.shopifyAddrDialog = false
      })
    },

    /**
     * @description: 同步shopify订单
     * @param {*}
     * @return {*}
     */
    async shopifyGet() {
      this.shopifyLoading = true
      const { code } = await shopifyOrderSync({ domain: this.shopifyDomain || '' })
      if (code === RESPONSE_SUCCESS) {
        this.searchChange()
      }
      this.$nextTick(() => {
        this.shopifyLoading = false
      })
    },
    /**
     * @description: 批量修改地址
     * @param {*}
     * @return {*}
     */
    async batchAddrUpdate() {
      if (!this.inventoryAddressId) {
        this.$message.warning(this.$lang('请选择发货仓库'))
        return
      }
      const ids = []
      this.multipleSelection.forEach(item => {
        if (item.orderStatusCode === 100) {
          ids.push(item.customerOrderId)
        }
      })
      this.shopifyLoading = true
      const { code, msg } = await shopifyOrderAddrUpdate({ customerOrderId: ids, inventoryAddressId: this.inventoryAddressId, domain: this.shopifyDomain || '' })
      if (code === RESPONSE_SUCCESS) {
        this.shopifyAddrDialog = false
        this.searchChange()
        this.$message.success(this.$lang('修改成功'))
      } else {
        this.$message.error(msg)
      }
      this.$nextTick(() => {
        this.shopifyLoading = false
      })
    },
    // 批量取消订单
    async batchCancelOrder() {
      const customerOrderId = []
      this.multipleSelection.forEach(item => {
        if (item.orderStatusCode === 100) {
          customerOrderId.push(item.customerOrderId)
        }
      })
      if (customerOrderId.length <= 0) {
        this.$message.warning(this.$lang('没有可取消的订单'))
        return
      }
      this.cancelLoading = true
      const { code, msg } = await cancelById({ customerOrderId, domain: this.shopifyDomain || '' })
      this.cancelLoading = false
      if (code === RESPONSE_SUCCESS) {
        this.$message.success(this.$lang('取消成功'))
      } else {
        this.$message.error(msg)
      }
      this.cancelSuccess()
    },

    // 选择日期
    selectDate() {
      console.log(this.searchParam.date, 'this.searchParam.date')
      const [start = '', end = ''] = this.searchParam.date
      this.searchParam.startTime = start
      this.searchParam.endTime = end
    },
    getParams() {
      const { orderStatusCode } = this.searchParam
      const searchParam = Object.assign({}, this.searchParam)
      // const arr = ['current', 'size', 'startTime', 'endTime', 'date', 'orderStatusCode', 'columnNames', 'sort', 'orderStatusCode', 'isVip']
      // Object.keys(searchParam).forEach(item => {
      //   if (!arr.includes(item)) {
      //     if (searchParam[item] instanceof Array && searchParam[item][0]) {
      //       delete searchParam.startTime
      //       delete searchParam.endTime
      //     } else if (typeof searchParam[item] === 'string' && searchParam[item]) {
      //       delete searchParam.startTime
      //       delete searchParam.endTime
      //     }
      //   }
      // })
      searchParam.orderStatusCode === '0' ? '' : orderStatusCode
      searchParam.isVip = false
      return searchParam
    },
    // 查询
    async searchChange(params) {
      const { startTime, endTime } = this.searchParam
      const space = 31 * 24 * 3600 * 1000
      const startTime1 = new Date(startTime).getTime()
      const endTime1 = new Date(endTime).getTime()
      if (endTime1 - startTime1 > space) {
        this.$message.error(this.$lang('开始时间与结束时间之差不能大于31天'))
        return
      }
      this.searchParam.orderStatusCode = this.menuItems.length > 0 ? this.menuItems[this.tabActive].orderStatusCode : ''
      this.searchParam.customerOrderId = this.searchParam.customerOrderId.length > 0 ? this.searchParam.customerOrderId : ''
      // 列表查询
      await this.searchFun(1)
      // 列表总数查询
      await this.orderTotalGroupThridNo(this.searchParam)
      this.multipleSelection = []
    },
    handleSelect(key) {
      const menuItems = this.menuItems
      this.searchParam.orderStatusCode = menuItems[key].orderStatusCode
      this.exportStatus = menuItems[key].orderStatusCode
      this.tabActive = key
      this.currentKey = parseInt(key)
      this.page.current = 1
      this.isCheckedAll = false
      // 重置表格滚动条置顶
      this.$refs.table.$el.querySelector('.el-table__body-wrapper').scrollTop = 0
      this.searchFun()
      // 清空选中数据
      this.multipleSelection = []
      this.autoPrint = false
      // 列表总数查询
      this.orderTotalGroupThridNo(this.searchParam)
      this.$nextTick(() => {
        this.$refs.table.$refs.table.doLayout()
      })
    },
    cancelFn(row) {
      this.selectId = row.id
      this.$refs.cancelOrder.dialogTableVisible = true
    },
    // 取消成功
    cancelSuccess() {
      this.multipleSelection = []
      this.isCheckedAll = false
      setTimeout(() => {
        this.orderTotalGroupThridNo(this.searchParam)
        this.searchFun()
      }, 1000)
    },
    // 获取tabs
    async orderTotalGroupThridNo(reqData) {
      // 状态数据统计
      reqData.isVip = false
      const params = this.getParams()
      // tabs默认获取全部，orderStatusCode默认不传
      params.orderStatusCode = ''
      const { code, data } = await orderTotalGroupThridNo(params)
      if (code === RESPONSE_SUCCESS) {
        const list = [...data]
        if (list.length > 0 && list[0].total === 0 && this.isKeyUp) {
          this.$message.warning('查询不到订单信息')
        }
        this.menuItems = list
      }
    },
    // 查看
    rowView(row) {
      this.selectId = row.id
      this.viewDialogVisible = true
      // 获取查看详情
      this.viewFun(row)
    },
    // close:关闭；delWaybill删除运单  ； cancelOrder:取消订单； ediOrder:编辑订单 delOrder:删除订单；
    closeDetails(val) {
      this.viewDialogVisible = val.viewDialogVisible
      switch (val.type) {
        case 'cancelOrder':
          this.$refs.cancelOrder.dialogTableVisible = true
          break
        case 'ediOrder':
          this.editDialogVisible = true
          break
        case 'delOrder':
          const item = {
            orderId: val.rowData.id
          }
          this.rowDel(item)
          break
      }
    },
    // 重置编辑表单
    clearFormItem() {
      this.$refs['editOrder'].$refs['orderForm'].resetFields()
    },
    // 重置搜索
    resetSearch() {
      this.searchParam = {
        date: commonFun.GetTodayDate(),
        startTime: commonFun.GetTodayDate()[0], // 开始时间，格式：yyyy-MM-dd HH:mm:ss
        endTime: commonFun.GetTodayDate()[1], // 结束时间，格式：yyyy-MM-dd HH:mm:ss
        customerOrderId: ''
      }
    },
    // 全选
    handleSelectAll1(val) {
      this.multipleSelection = val
      this.originSelectionAll = [...val]
      if (val.length) {
        this.isCheckedAll = true
      } else {
        this.isCheckedAll = false
      }
    },
    // 单个选中
    handleSelectionChange(val, currentRow) {
      // 检测当前行的选中状态
      const isChecked = val.some(item => item.id === currentRow.id)
      if (this.isCheckedAll) {
        if (!isChecked) {
          this.isSinleSelection = [...(this.isSinleSelection || []), currentRow.id]
        } else {
          this.isSinleSelection = this.isSinleSelection.filter(item => item !== currentRow.id)
        }
        this.multipleSelection = this.originSelectionAll.filter(item => !this.isSinleSelection.includes(item.id))
      } else {
        this.multipleSelection = val
      }
    },
    changeTab(index) {
      this.tabActive = index
      this.handleSelect(index)
    },
    // 下单
    async setOrder() {
      try {
        this.failData = []
        this.keyBtn = true
        if (this.multipleSelection.length === 0) return this.$message.warning(this.$lang('请选择要下单的订单'))
        const orders = []
        this.multipleSelection.forEach((item, index) => {
          orders.push({
            ...item,
            sallaOrderId: item.id,
            goodsTypeName: 'Others1',
            goodsTypeCode: 'ITN4',
            id: ''
          })
        })

        // 下单前各按钮和提示按钮初始化
        const { code, msg, data } = await batchSave({
          orders: orders
        })
        this.keyBtn = false
        if (code === RESPONSE_SUCCESS) {
          console.log(data, '返回的数据')
          this.multipleSelection = []
          this.isCheckedAll = false
          this.$message.success(this.$lang('下单成功'))
          setTimeout(() => {
            this.orderTotalGroupThridNo(this.searchParam)
            this.searchFun()
          }, 1000)
        } else {
          this.$message.error(msg)
          this.$nextTick(() => {
            this.multipleSelection.forEach((item, index) => {
              this.failData[index] = { customerOrderId: item.customerOrderId }
            })
            this.$refs.failOrder.dialogTableVisible = true
          })
        }
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0;
}
.el-menu-item {
  height: 32px;
  line-height: 32px;
  padding: 0 3px;
  margin: 0 20px;
  text-align: center;
}
.el-menu-item:first-of-type {
  padding-left: 0;
  margin-left: 0;
  text-align: left;
}
input {
  font-size: 12px !important;
}
.externalOrder {
  .externalOrder-top {
    padding: 16px 24px;
    .commonSize {
      width: 328px !important;
      height: 32px !important;
    }
  }
  .externalOrder-bottom {
    padding: 12px 24px;
    flex: 1;
    display: flex;
    flex-direction: column;
    background: #edeef3;
    box-sizing: border-box;
  }

  .search-btns {
    margin-bottom: 10px;
  }
  .tabs-nav {
    // margin: 5px 0 9px;
    .tabs-nav-item {
      display: inline-block;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      background: #fff;
      border: 1px solid #dcdfe6;
      -webkit-appearance: none;
      text-align: center;
      box-sizing: border-box;
      outline: none;
      margin: 0;
      transition: 0.1s;
      font-weight: 500;
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      padding: 12px 20px;
      font-size: 16px;
      background: #e0e1e7;
      height: 40px;
      border: 0;
      background: #e0e1e7;
      border-radius: 8px 8px 0 0;
      color: #666;
      margin-left: 10px;
      &:first-of-type {
        margin-left: 0px;
      }
      i {
        margin-right: 8px;
        color: #666;
      }
      &.active {
        background: #fff;
        color: #e60012;
        i {
          color: #e60012;
        }
      }
    }
    .tabs-nav-item-count {
      display: inline-block;
      width: 35px;
      height: 20px;
      font-size: 12px;
      line-height: 20px;
      background: rgba(102, 102, 102, 0.1);
      border-radius: 10px;
      margin-left: 5px;
    }
  }
}
</style>
<style lang="scss">
.externalOrder .externalOrder-top .el-input__inner {
  margin-bottom: 10px;
}
.customerWaybillNos .el-input__inner {
  margin-bottom: 0px !important;
}
</style>
